import { createContext, useContext } from "react";

export const ReaderContext = createContext({ goTo: () => {}, openMedia: null, ui: {}, edition: null, interactive: true });
export const useReader = () => useContext(ReaderContext);
export const useRtl = () => useContext(ReaderContext).edition?.dir === "rtl";
